<template>
  <div class="trigger-event-container">
    <TriggerEventCard
      :trigger-event="triggerEvent"
      :forms="forms"
      :editable="editable"
      @click:setting="handleSettingBtnClick"
    />
  </div>
</template>

<script lang="ts" setup>
import { TriggerEventBody, TriggerEventForm } from '@/api/openapi';
import TriggerEventCard from '@/components/organisms/user/trigger/TriggerEventCard.vue';
import { TTriggerEventFormMode } from './types';

type TProps = {
  triggerEvent: TriggerEventBody | null;
  forms?: TriggerEventForm[];
  editable: boolean;
};
type TEmit = {
  'click:triggerEvent': [triggerEvent: TriggerEventBody, mode: TTriggerEventFormMode];
};
const props = withDefaults(defineProps<TProps>(), {
  forms: () => [],
});
const emit = defineEmits<TEmit>();

const handleSettingBtnClick = (mode: TTriggerEventFormMode) => {
  emit('click:triggerEvent', props.triggerEvent || {
    leadViewId: null,
    eventType: null,
    filterParams: {},
    eventDetail: {},
  }, mode);
};
</script>
